import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../examples/Footer";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";

import Grid from "@mui/material/Grid";
// Büyük sayfada her tuşta tüm sayfanın yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreateServiceProvider from "../crm/Service Provider/CreateServiceProvider";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import MenuItem from "@mui/material/MenuItem";
import { Autocomplete } from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import tr from "date-fns/locale/tr";

import RequiredLabelWithTooltip from "../../../../../assets/theme/components/form/RequiredLabelWithTooltip";
import MDDropzone from "../../../../../components/MDDropzone";
import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";
import CrudService from "services/cruds-service";
import LocationHistory from "./LocationHistory";

// Map picker
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import CmrPrintDialog from "./CmrPrintDialog";
import { TrucksSection } from "./RoadTrucks";
import RmblReferences from "./RmblReferences";
import { buildRmblInvoicePayload } from "./rmblInvoice";
import ViewShipments from "../crm/invoice";
import {
    TRUCK_TYPE_OPTIONS,
    cmrPayloadsForTrucks,
    emptyTruck,
    normalizeCargoList,
    totalBuyingRate,
    trucksForPayload,
    trucksFromSaved,
    vehicleText,
} from "./roadTruckModel";
import { appAlert } from "components/AppDialog";
import { FinanceKpi, FinancialSummaryPanel, KpiStrip, formatMoney, formatQuantity, formatPercent, profitTone, profitLabel } from "components/MblSummary";

// Leaflet marker icon fix
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function safeNumber(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
}

function formatNumber(v, digits = 4) {
    return Number(v || 0).toFixed(digits);
}
function normalizeStringField(value) {
    if (Array.isArray(value)) {
        return value[0] ?? "";
    }
    return value ?? "";
}

const getProfitColor = (value) => {
    const n = Number(value || 0);
    if (n > 0) return "success";
    if (n === 0) return "warning";
    return "error";
};

function convertCurrency(amount, fromCurrency, toCurrency, rates) {
    const value = safeNumber(amount);

    if (!value) return 0;
    if (!fromCurrency || !toCurrency) return value;
    if (fromCurrency === toCurrency) return value;
    if (!rates) return value;

    if (fromCurrency === "USD") {
        return value * safeNumber(rates[toCurrency]);
    }

    if (toCurrency === "USD") {
        return value / safeNumber(rates[fromCurrency]);
    }

    const inUsd = value / safeNumber(rates[fromCurrency]);
    return inUsd * safeNumber(rates[toCurrency]);
}

const initialAddressState = {
    additionalInfo: "",
    gateway: "",
    country: "",
    city: "",
    district: "",
    latLong: "",
    zipcode: "",
    officeCode: "",
    brokerageName: "",
    pickupType: "Direct Pickup",
    deliveryType: "Direct Delivery",
    serviceProvider: "",
};

function MapClicker({ onPick }) {
    useMapEvents({
        click(e) {
            onPick(e.latlng);
        },
    });
    return null;
}

function SectionCard({ title, subtitle, children, rightAction }) {
    return (
        <Card
            sx={{
                mb: 3,
                p: { xs: 2, md: 2.75 },
                borderRadius: "10px",
                border: "1px solid rgba(148,163,184,0.22)",
                background:
                    "rgba(255,255,255,0.98)",
                boxShadow: "none",
                overflow: "hidden",
                position: "relative",
                "&:before": {
                    content: '\"\"',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 4,
                    background: "#0ea5e9",
                },
            }}
        >
            <MDBox
                mb={2}
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                flexDirection={{ xs: "column", md: "row" }}
                gap={1.5}
            >
                <MDBox>
                    <MDTypography variant="h6" fontWeight="bold" sx={{ color: "#0f172a" }}>
                        {title}
                    </MDTypography>
                    {subtitle ? (
                        <MDTypography
                            variant="caption"
                            color="text"
                            sx={{ maxWidth: 760, display: "block" }}
                        >
                            {subtitle}
                        </MDTypography>
                    ) : null}
                </MDBox>

                {rightAction ? <MDBox>{rightAction}</MDBox> : null}
            </MDBox>

            <Divider sx={{ mb: 2, borderColor: "rgba(148,163,184,0.20)" }} />
            {children}
        </Card>
    );
}

function DocumentUploadCard({ title, files, setFiles, titleSx, wrapperSx, dzStyle }) {
    const uploaded = Boolean(files?.length);
    return (
        <Card
            sx={{
                p: 2,
                borderRadius: "10px",
                border: uploaded
                    ? "1px solid rgba(34,197,94,0.32)"
                    : "1px dashed rgba(148,163,184,0.45)",
                textAlign: "center",
                height: "100%",
                background: uploaded
                    ? "rgba(240,253,244,0.92)"
                    : "rgba(248,250,252,0.95)",
                boxShadow: "none",
                transition: "all 0.25s ease",
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "none",
                    borderColor: uploaded ? "rgba(34,197,94,0.55)" : "rgba(14,165,233,0.55)",
                },
            }}
        >
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                <MDTypography
                    variant="caption"
                    fontWeight="bold"
                    sx={{ ...titleSx, textAlign: "left", mb: 0 }}
                >
                    {title}
                </MDTypography>

                <Chip
                    size="small"
                    color={uploaded ? "success" : "default"}
                    label={uploaded ? "Uploaded" : "Pending"}
                    sx={{ fontWeight: "bold" }}
                />
            </MDBox>

            <MDBox
                sx={{
                    ...wrapperSx,
                    borderRadius: "10px",
                    backgroundColor: "rgba(255,255,255,0.78)",
                    border: "1px solid rgba(226,232,240,0.85)",
                }}
                mx="auto"
            >
                <MDDropzone
                    options={{
                        addRemoveLinks: true,
                        maxFilesize: 10000,
                        maxFiles: 1,
                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                        timeout: 0,
                    }}
                    onChange={(incomingFiles) => setFiles(incomingFiles)}
                    style={dzStyle}
                />
            </MDBox>

            <MDBox mt={1.5}>
                <UploadedFilePreview file={files} layout="stack" onRemove={() => setFiles([])} />
            </MDBox>
        </Card>
    );
}

function LocationPickerModal({
                                 open,
                                 title,
                                 initialCenter = { lat: 41.0082, lng: 28.9784 },
                                 valueLatLng,
                                 onClose,
                                 onSelect,
                             }) {
    const [picked, setPicked] = useState(valueLatLng || null);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setPicked(valueLatLng || null);
    }, [valueLatLng, open]);

    const centerLat = Number.isFinite(picked?.lat) ? picked.lat : initialCenter.lat;
    const centerLng = Number.isFinite(picked?.lng) ? picked.lng : initialCenter.lng;

    const searchLocation = async () => {
        if (!searchText) return;

        try {
            const res = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchText)}`
            );

            const data = await res.json();

            if (data && data.length > 0) {
                const lat = parseFloat(data[0].lat);
                const lng = parseFloat(data[0].lon);
                setPicked({ lat, lng });
            } else {
                appAlert("Location not found");
            }
        } catch (err) {
            console.error("Search error:", err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <MDBox mb={2} display="flex" gap={1}>
                    <TextField
                        label="Search City / Country / Zipcode"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                searchLocation();
                            }
                        }}
                        variant="outlined"
                        fullWidth
                    />

                    <MDButton variant="contained" color="info" onClick={searchLocation}>
                        Search
                    </MDButton>
                </MDBox>

                <MDBox sx={{ height: 420, width: "100%" }}>
                    <MapContainer
                        center={[centerLat, centerLng]}
                        zoom={6}
                        style={{ height: "100%", width: "100%" }}
                        key={`${centerLat}-${centerLng}`}
                    >
                        <TileLayer
                            attribution="&copy; OpenStreetMap contributors"
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                        <MapClicker onPick={(latlng) => setPicked(latlng)} />
                        {Number.isFinite(picked?.lat) && Number.isFinite(picked?.lng) && (
                            <Marker position={[picked.lat, picked.lng]} />
                        )}
                    </MapContainer>
                </MDBox>

                <MDBox mt={2} display="flex" gap={2}>
                    <TextField
                        label="Latitude"
                        value={picked?.lat ?? ""}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        variant="outlined"
                    />

                    <TextField
                        label="Longitude"
                        value={picked?.lng ?? ""}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        variant="outlined"
                    />
                </MDBox>

                <MDTypography variant="caption" color="text">
                    You can search a city, country or zipcode and then click on the map to refine the
                    location.
                </MDTypography>
            </DialogContent>

            <DialogActions>
                <MDButton variant="contained" color="dark" onClick={onClose}>
                    Cancel
                </MDButton>

                <MDButton
                    variant="contained"
                    color="success"
                    onClick={() => {
                        if (picked) onSelect(picked);
                    }}
                    disabled={!picked}
                >
                    Select
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}

const ConnectMBL = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const mblIdFromUrl = useMemo(() => {
        const sp = new URLSearchParams(location.search);
        return sp.get("id");
    }, [location.search]);

    const isEditMode = Boolean(mblIdFromUrl);

    const CURRENCY_OPTIONS = ["USD", "EUR", "GBP", "TRY"];

    const [serviceProviders, setServiceProviders] = useState([]);
    const [selectedLinehaulProvider, setSelectedLinehaulProvider] = useState(null);
    const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);

    // Same "+ New Account" entry the other party inputs have.
    const NEW_SERVICE_PROVIDER_OPTION = {
        id: "new-service-provider",
        name: "+ New Account",
        type: "new",
    };

    const handleServiceProviderCreatedFromModal = (createdProvider) => {
        const attr = createdProvider?.attributes || createdProvider;
        const newOption = {
            id: createdProvider?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Service Provider",
        };

        setServiceProviders((prev) =>
            prev.some((item) => String(item.name).toLowerCase() === newOption.name.toLowerCase())
                ? prev
                : [...prev, newOption]
        );
        setSelectedLinehaulProvider(newOption);
        setServiceProviderModalOpen(false);
    };
    const [linehaulCost, setLinehaulCost] = useState("");
    const [linehaulCurrency, setLinehaulCurrency] = useState("EUR");
    const [handlingCost, setHandlingCost] = useState("");
    const [handlingCurrency, setHandlingCurrency] = useState("EUR");
    const [totalCurrency, setTotalCurrency] = useState("EUR");
    const [exchangeRates, setExchangeRates] = useState(null);
    const [shipmentPricing, setShipmentPricing] = useState({});
    const [saving, setSaving] = useState(false);
    // CMR shown in the print preview; null while it is closed.
    const [cmrDocuments, setCmrDocuments] = useState(null);
    // Id of the RMBL created on this screen. Every action that saves first (print, invoice,
    // consolidation) must update that record after the first create instead of creating another.
    const createdMblIdRef = useRef(null);
    const saveInFlightRef = useRef(null);
    const [addLocationTrigger, setAddLocationTrigger] = useState(0);

    const [selectedShipmentsState, setSelectedShipmentsState] = useState(
        location.state?.selectedShipments || []
    );

    // Cost / Selling Rate currency: the one entered on the linked RHFL file(s) (selling rate,
    // else buying rate), not a default. A currency picked by hand on this page is kept.
    const totalCurrencyTouchedRef = useRef(false);
    const hflCurrency = useMemo(() => {
        const attrs = (selectedShipmentsState || []).map((shipment) => shipment?.attributes || {});
        const pick = (key) => attrs.map((attr) => attr[key]).find(Boolean);
        return pick("sellingRateCurrency") || pick("buyingRateCurrency") || "";
    }, [selectedShipmentsState]);

    useEffect(() => {
        if (hflCurrency && !totalCurrencyTouchedRef.current) setTotalCurrency(hflCurrency);
    }, [hflCurrency]);

    const hasData = selectedShipmentsState.length > 0;
    const isSingle = selectedShipmentsState.length === 1;
    const firstAttr = selectedShipmentsState?.[0]?.attributes || null;

    const [rmblNumber, setRmblNumber] = useState("");

    const [actualDeparture, setActualDeparture] = useState(null);
    const [actualDepartureTime, setActualDepartureTime] = useState("");

    const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);
    const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState("");

    const [sealNumber, setSealNumber] = useState("");
    const [cmrNumber, setCmrNumber] = useState("");
    const [plateContainerNumber, setPlateContainerNumber] = useState("");

    // LTL: the RMBL's own linehaul trucks and which of them carries each RHFL
    // (shipment id -> truckId; an RHFL without one is on the first truck).
    const [linehaulTrucks, setLinehaulTrucks] = useState(() => [emptyTruck()]);
    const [truckAssignments, setTruckAssignments] = useState({});
    // The RMBL keeps a snapshot of each RHFL from when it was connected; the trucks are read
    // from the current RHFL records instead. Corrections made here ({ shipmentId: { truckId:
    // { field: value } } }) are written back to the RHFLs when the RMBL is saved.
    const [currentRhfls, setCurrentRhfls] = useState({});
    const [rhflsLoading, setRhflsLoading] = useState(false);
    const [rhflTruckEdits, setRhflTruckEdits] = useState({});

    // Schedule tracking as on the OMBL: first ETA, actual arrival, requested delivery and the
    // reason when the ETA moves later.
    const [originalEtaDate, setOriginalEtaDate] = useState(null);
    const [aadDate, setAadDate] = useState(null);
    const [aadTime, setAadTime] = useState("");
    const [rdlDate, setRdlDate] = useState(null);
    const [rdlTime, setRdlTime] = useState("");
    const [delayReason, setDelayReason] = useState("");

    const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
    const [invoiceState, setInvoiceState] = useState(null);

    const [t1t2, setT1t2] = useState([]);
    const [linehaulCarrier, setLinehaulCarrier] = useState([]);
    const [cmr, setCmr] = useState([]);

    const [pickupLocation, setPickupLocation] = useState(initialAddressState);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressState);
    const [locationHistory, setLocationHistory] = useState([]);
    const [refreshLocationHistory, setRefreshLocationHistory] = useState(false);

    const [pickupDate, setPickupDate] = useState(null);
    const [pickupTime, setPickupTime] = useState("");

    const [estimatedDeparture, setEstimatedDeparture] = useState(null);
    const [estimatedDepartureTime, setEstimatedDepartureTime] = useState("");

    const [proofOfDelivery, setProofOfDelivery] = useState(null);
    const [proofOfDeliveryTime, setProofOfDeliveryTime] = useState("");

    const [pickupPickerOpen, setPickupPickerOpen] = useState(false);
    const [deliveryPickerOpen, setDeliveryPickerOpen] = useState(false);
    const FILENDERS_NAME = "FILENDERS LOGISTICS AND TECHNOLOGY";

    const [globalAgentOptions, setGlobalAgentOptions] = useState([]);

    const [bookingResponsibleParty, setBookingResponsibleParty] = useState("");
    const [selectedBookingAgent, setSelectedBookingAgent] = useState(null);

    const [originAgentEnabled, setOriginAgentEnabled] = useState("");
    const [selectedOriginAgent, setSelectedOriginAgent] = useState(null);
    const [originActualType, setOriginActualType] = useState("");

    const [destinationAgentEnabled, setDestinationAgentEnabled] = useState("");
    const [selectedDestinationAgent, setSelectedDestinationAgent] = useState(null);
    const [destinationActualType, setDestinationActualType] = useState("");

    useEffect(() => {
        const fetchGlobalAgents = async () => {
            try {
                const response = await CrudService.getGlobalAgents();

                const options = (response?.data || []).map((item) => {
                    const attr = item.attributes || {};

                    return {
                        id: item.id,
                        name: attr.name || attr.companyName || "Unnamed Global Agent",
                        globalAgentCountry: attr.globalAgentCountry || "",
                        servicesCountry: attr.servicesCountry || [],
                        raw: attr,
                    };
                });

                setGlobalAgentOptions(options);
            } catch (error) {
                console.error("Global Agent verileri alınırken hata oluştu:", error);
                setGlobalAgentOptions([]);
            }
        };

        fetchGlobalAgents();
    }, []);

    const fetchExchangeRates = async () => {
        try {
            const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
            return await res.json();
        } catch (error) {
            console.error("API Error:", error);
            return null;
        }
    };

    function safeCurrency(v, fallback = "EUR") {
        return v || fallback;
    }

    useEffect(() => {
        const loadRates = async () => {
            const data = await fetchExchangeRates();
            if (data?.rates) {
                setExchangeRates(data.rates);
            }
        };
        loadRates();
    }, []);

    useEffect(() => {
        if (isEditMode) return;

        const fetchNextRmblNumber = async () => {
            try {
                const res = await CrudService.getNextRMBLNumber();
                const nextNumber = res?.data?.rmblNumber || res?.data?.data?.rmblNumber || "RMBL0001";
                setRmblNumber(nextNumber);
            } catch (error) {
                console.error("Next RMBL number fetch error:", error);
                setRmblNumber("RMBL0001");
            }
        };

        fetchNextRmblNumber();
    }, [isEditMode]);

    useEffect(() => {
        const stateShipments = location.state?.selectedShipments || [];
        if (!isEditMode && stateShipments.length) {
            setSelectedShipmentsState(stateShipments);
        }
    }, [location.state, isEditMode]);

    useEffect(() => {
        if (!isEditMode) return;

        const run = async () => {
            try {
                const res = await CrudService.getMBLById(mblIdFromUrl);
                const attr = res?.data?.data?.attributes || res?.data?.attributes || null;

                if (!attr) return;

                setRmblNumber(attr.rmblNumber || "RMBL0001");
                setPickupDate(attr.pickupDate ? new Date(attr.pickupDate) : null);
                setPickupTime(attr.pickupTime || "");

                setProofOfDelivery(attr.proofOfDelivery ? new Date(attr.proofOfDelivery) : null);
                setProofOfDeliveryTime(attr.proofOfDeliveryTime || "");
                setActualDeparture(attr.cob ? new Date(attr.cob) : null);
                setActualDepartureTime(attr.cobTime || "");

                setEstimatedDeliveryDate(attr.eta ? new Date(attr.eta) : null);
                setEstimatedDeliveryTime(attr.etaTime || "");

                setSealNumber(attr.sealNumber || "");
                setCmrNumber(attr.cmrNumber || "");
                setPlateContainerNumber(attr.plateContainerNumber || "");
                // RMBLs saved before linehaul trucks get one from their plate / CMR / seal.
                setLinehaulTrucks(
                    attr.trucks?.length
                        ? trucksFromSaved({ trucks: attr.trucks })
                        : [
                            emptyTruck({
                                truckId: `truck-${mblIdFromUrl}-1`,
                                plate: attr.plateContainerNumber || "",
                                cmrNumber: attr.cmrNumber || "",
                                sealNumber: attr.sealNumber || "",
                            }),
                        ]
                );
                setTruckAssignments(attr.truckAssignments || {});
                setOriginalEtaDate(
                    attr.originalEtaDate ? new Date(attr.originalEtaDate) : attr.eta ? new Date(attr.eta) : null
                );
                setAadDate(attr.aadDate ? new Date(attr.aadDate) : null);
                setAadTime(attr.aadTime || "");
                setRdlDate(attr.rdlDate ? new Date(attr.rdlDate) : null);
                setRdlTime(attr.rdlTime || "");
                setDelayReason(attr.delayReason || "");

                // Backend bu alanları tekil string (dosya yolu) olarak saklar; state ise dizi bekler
                setT1t2(attr.t1t2 ? [attr.t1t2] : []);
                setLinehaulCarrier(attr.linehaulCarrier ? [attr.linehaulCarrier] : []);
                setCmr(attr.cmr ? [attr.cmr] : []);

                setPickupLocation({
                    ...initialAddressState,
                    ...(attr?.pickupLocation || {}),
                    additionalInfo: normalizeStringField(attr?.pickupLocation?.additionalInfo),
                });

                setDeliveryLocation({
                    ...initialAddressState,
                    ...(attr?.deliveryLocation || {}),
                    additionalInfo: normalizeStringField(attr?.deliveryLocation?.additionalInfo),
                });
                setLocationHistory(Array.isArray(attr.locationHistory) ? attr.locationHistory : []);

                setPickupDate(attr.pickupDate ? new Date(attr.pickupDate) : null);
                setPickupTime(attr.pickupTime || "");

                setEstimatedDeparture(
                    attr.estimatedDeparture ? new Date(attr.estimatedDeparture) : null
                );
                setEstimatedDepartureTime(attr.estimatedDepartureTime || "");

                setProofOfDelivery(attr.proofOfDelivery ? new Date(attr.proofOfDelivery) : null);
                setProofOfDeliveryTime(attr.proofOfDeliveryTime || "");

                setShipmentPricing(attr.shipmentPricing || {});
                setSelectedLinehaulProvider(attr.linehaulDetails?.provider?.id ? attr.linehaulDetails.provider : null);
                setLinehaulCost(attr.linehaulDetails?.cost ?? "");
                setLinehaulCurrency(attr.linehaulDetails?.currency || "EUR");
                setHandlingCost(attr.handlingDetails?.cost ?? "");
                setHandlingCurrency(attr.handlingDetails?.currency || "EUR");
                // The RHFL file's currency wins over the copy saved on this record.
                if (!hflCurrency) {
                    setTotalCurrency(attr.financialSummary?.totalCurrency || "EUR");
                }
                setBookingResponsibleParty(attr.bookingResponsibleParty || "");
                setSelectedBookingAgent(attr.selectedBookingAgent?.id ? attr.selectedBookingAgent : null);

                setOriginAgentEnabled(attr.originAgentEnabled || "");
                setSelectedOriginAgent(attr.selectedOriginAgent?.id ? attr.selectedOriginAgent : null);
                setOriginActualType(attr.originActualType || "");

                setDestinationAgentEnabled(attr.destinationAgentEnabled || "");
                setSelectedDestinationAgent(attr.selectedDestinationAgent?.id ? attr.selectedDestinationAgent : null);
                setDestinationActualType(attr.destinationActualType || "");

                const snap = Array.isArray(attr.shipments) ? attr.shipments : [];
                const normalized = snap
                    .map((x) => {
                        if (x?.attributes) return x;
                        if (x?.id && x) return { id: x.id, attributes: x.attributes || x };
                        return null;
                    })
                    .filter(Boolean);

                setSelectedShipmentsState(normalized);
            } catch (err) {
                console.error("getMBLById error:", err?.response?.data || err);
                appAlert("MBL could not be loaded. Please try again.");
            }
        };

        run();
    }, [isEditMode, mblIdFromUrl]);

    useEffect(() => {
        if (isEditMode) return;
        if (!firstAttr) return;

        setPickupLocation({
            ...initialAddressState,
            ...(firstAttr.pickupLocation || {}),
            additionalInfo: normalizeStringField(firstAttr.pickupLocation?.additionalInfo),
        });
        setDeliveryLocation({
            ...initialAddressState,
            ...(firstAttr.deliveryLocation || {}),
            additionalInfo: normalizeStringField(firstAttr.deliveryLocation?.additionalInfo),
        });

        setPickupDate(firstAttr.pickupDate ? new Date(firstAttr.pickupDate) : null);
        setPickupTime(firstAttr.pickupTime || "");

        setEstimatedDeparture(
            firstAttr.estimatedDeparture ? new Date(firstAttr.estimatedDeparture) : null
        );
        setEstimatedDepartureTime(firstAttr.estimatedDepartureTime || "");

        setEstimatedDeliveryDate(
            (prev) =>
                prev ||
                (firstAttr.estimatedDeliveryDate ? new Date(firstAttr.estimatedDeliveryDate) : null)
        );
        setEstimatedDeliveryTime((prev) => prev || (firstAttr.estimatedDeliveryTime || ""));
        setOriginalEtaDate(
            (prev) => prev || (firstAttr.estimatedDeliveryDate ? new Date(firstAttr.estimatedDeliveryDate) : null)
        );

        setActualDeparture(
            (prev) =>
                prev || (firstAttr.actualDeparture ? new Date(firstAttr.actualDeparture) : null)
        );
        setActualDepartureTime((prev) => prev || (firstAttr.actualDepartureTime || ""));

        setProofOfDelivery(firstAttr.proofOfDelivery ? new Date(firstAttr.proofOfDelivery) : null);
        setProofOfDeliveryTime(firstAttr.proofOfDeliveryTime || "");

        setLocationHistory(firstAttr.locationHistory || []);
    }, [firstAttr, isEditMode]);
    useEffect(() => {
        if (!selectedShipmentsState?.length) return;

        setShipmentPricing((prev) => {
            const next = { ...prev };

            selectedShipmentsState.forEach((shipment) => {
                const id = shipment?.id;
                const attr = shipment?.attributes || {};

                if (!id) return;

                if (!next[id]) {
                    next[id] = {
                        cost:
                            safeNumber(attr.buyingRate) +
                            safeNumber(attr.pickupRate) +
                            safeNumber(attr.deliveryRate) +
                            safeNumber(attr.exportCustomsRate) +
                            safeNumber(attr.importCustomsRate),
                        costCurrency:
                            attr.buyingRateCurrency ||
                            attr.pickupRateCurrency ||
                            attr.deliveryRateCurrency ||
                            attr.exportCustomsRateCurrency ||
                            attr.importCustomsRateCurrency ||
                            "EUR",
                        sellingRate: safeNumber(attr.sellingRate),
                        sellingRateCurrency: safeCurrency(attr.sellingRateCurrency, "EUR"),
                        profit: 0,
                        profitCurrency: totalCurrency,
                    };
                }
            });

            return next;
        });
    }, [selectedShipmentsState, totalCurrency]);

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getServiceProviders();
                const options = (response?.data || []).map((item) => ({
                    id: item.id,
                    name: item.attributes?.name || "Unnamed Service Provider",
                }));
                setServiceProviders(options);
            } catch (error) {
                console.error("Service Provider verileri alınırken hata oluştu:", error);
                setServiceProviders([]);
            }
        };

        fetchServiceProviders();
    }, []);

    const linkTextSx = {
        cursor: "pointer",
        textDecoration: "underline",
        "&:hover": {
            opacity: 0.8,
        },
    };

    const pricingComputed = useMemo(() => {
        const rows = selectedShipmentsState.map((s) => {
            const a = s.attributes || {};
            const pricing = shipmentPricing?.[s.id] || {};

            const shipmentCost =
                pricing.cost ??
                (safeNumber(a.buyingRate) +
                    safeNumber(a.pickupRate) +
                    safeNumber(a.deliveryRate) +
                    safeNumber(a.exportCustomsRate) +
                    safeNumber(a.importCustomsRate));

            const shipmentCostCurrency =
                pricing.costCurrency ||
                a.buyingRateCurrency ||
                a.pickupRateCurrency ||
                a.deliveryRateCurrency ||
                a.exportCustomsRateCurrency ||
                a.importCustomsRateCurrency ||
                "EUR";

            const shipmentSellingRate = pricing.sellingRate ?? safeNumber(a.sellingRate);

            const shipmentSellingRateCurrency =
                pricing.sellingRateCurrency || a.sellingRateCurrency || "EUR";

            return {
                id: s.id,
                shipmentNo: `RHFL${a.shipmentNo || 0}`,
                cost: safeNumber(shipmentCost),
                costCurrency: shipmentCostCurrency,
                sellingRate: safeNumber(shipmentSellingRate),
                sellingRateCurrency: shipmentSellingRateCurrency,
            };
        });

        const shipmentCostTotal = rows.reduce((acc, row) => {
            return acc + convertCurrency(row.cost, row.costCurrency, totalCurrency, exchangeRates);
        }, 0);

        const shipmentSellingTotal = rows.reduce((acc, row) => {
            return (
                acc +
                convertCurrency(row.sellingRate, row.sellingRateCurrency, totalCurrency, exchangeRates)
            );
        }, 0);

        const convertedLinehaulCost = convertCurrency(
            safeNumber(linehaulCost),
            linehaulCurrency,
            totalCurrency,
            exchangeRates
        );

        const convertedHandlingCost = convertCurrency(
            safeNumber(handlingCost),
            handlingCurrency,
            totalCurrency,
            exchangeRates
        );

        const totalCost = shipmentCostTotal + convertedLinehaulCost + convertedHandlingCost;
        const totalProfit = shipmentSellingTotal - totalCost;

        const shipmentCount = rows.length || 1;
        const distributedProfit = totalProfit / shipmentCount;

        const rowsWithProfit = rows.map((row) => ({
            ...row,
            profit: distributedProfit,
            profitCurrency: totalCurrency,
        }));

        return {
            rows: rowsWithProfit,
            shipmentCostTotal,
            shipmentSellingTotal,
            convertedLinehaulCost,
            convertedHandlingCost,
            totalCost,
            totalProfit,
            distributedProfit,
        };
    }, [
        selectedShipmentsState,
        shipmentPricing,
        totalCurrency,
        exchangeRates,
        linehaulCost,
        linehaulCurrency,
        handlingCost,
        handlingCurrency,
    ]);

    const financialSummary = useMemo(() => {
        return {
            shipmentCostTotal: pricingComputed.shipmentCostTotal,
            convertedLinehaulCost: pricingComputed.convertedLinehaulCost,
            convertedHandlingCost: pricingComputed.convertedHandlingCost,
            totalCost: pricingComputed.totalCost,
            totalSellingRate: pricingComputed.shipmentSellingTotal,
            totalProfit: pricingComputed.totalProfit,
        };
    }, [pricingComputed]);


    const computed = useMemo(() => {
        const rows = selectedShipmentsState.map((s) => {
            const a = s.attributes || {};
            const totals = a.totals || {};
            const cargo = Array.isArray(a.cargoDetails) ? a.cargoDetails : [];

            const grossFromCargo = cargo.reduce((sum, c) => sum + safeNumber(c?.grossWeight), 0);

            const grossWeight =
                safeNumber(totals.totalGrossWeight) ||
                safeNumber(totals.grossWeight) ||
                grossFromCargo;

            const ldm = safeNumber(totals.totalLdm);
            const chargeableWeight = safeNumber(totals.totalChargeableWeight);

            const unitFromCargo = cargo.reduce(
                (sum, c) => sum + safeNumber(c?.unitQuantity || c?.pcs || c?.quantity),
                0
            );

            const unit = safeNumber(totals.totalUnit) || safeNumber(totals.totalPcs) || unitFromCargo;

            const shipper =
                a.shipper?.companyName ||
                a.shipper?.name ||
                a.shipper ||
                a.pickupLocation?.companyName ||
                a.pickupLocation?.name ||
                "N/A";

            const consignee =
                a.consignee?.companyName ||
                a.consignee?.name ||
                a.consignee ||
                a.deliveryLocation?.companyName ||
                a.deliveryLocation?.name ||
                "N/A";

            return {
                id: s.id,
                shipmentNo: `RHFL${a.shipmentNo || 0}`,
                grossWeight,
                ldm,
                unit,
                chargeableWeight,
                shipper,
                consignee,
            };
        });

        const totals = rows.reduce(
            (acc, r) => {
                acc.grossWeight += safeNumber(r.grossWeight);
                acc.ldm += safeNumber(r.ldm);
                acc.unit += safeNumber(r.unit);
                acc.chargeableWeight += safeNumber(r.chargeableWeight);
                return acc;
            },
            { grossWeight: 0, ldm: 0, unit: 0, chargeableWeight: 0 }
        );

        return { rows, totals };
    }, [selectedShipmentsState]);

    const profitMargin = useMemo(() => {
        if (!safeNumber(financialSummary.totalSellingRate)) return 0;
        return (safeNumber(financialSummary.totalProfit) / safeNumber(financialSummary.totalSellingRate)) * 100;
    }, [financialSummary.totalProfit, financialSummary.totalSellingRate]);

    const pricingTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Cost</b>, accessor: "cost" },
            { Header: () => <b>Selling Rate</b>, accessor: "sellingRate" },
            { Header: () => <b>Profit</b>, accessor: "profit" },
        ],
        rows: [
            ...pricingComputed.rows.map((row) => ({
                shipmentNo: (
                    <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        color="info"
                        sx={linkTextSx}
                        onClick={() => handleGoShipmentForm(row.id)}
                    >
                        {row.shipmentNo}
                    </MDTypography>
                ),
                cost: `${formatNumber(row.cost, 2)} ${row.costCurrency}`,
                sellingRate: `${formatNumber(row.sellingRate, 2)} ${row.sellingRateCurrency}`,
                profit: (
                    <span style={{ fontWeight: 700 }}>
                        <MDTypography
                            variant="caption"
                            fontWeight="bold"
                            color={getProfitColor(row.profit)}
                        >
                            {formatNumber(row.profit, 2)} {row.profitCurrency}
                        </MDTypography>
                    </span>
                ),            })),
            {
                shipmentNo: <strong>TOTAL</strong>,
                cost: (
                    <strong>
                        {formatNumber(pricingComputed.shipmentCostTotal, 2)} {totalCurrency}
                    </strong>
                ),
                sellingRate: (
                    <strong>
                        {formatNumber(pricingComputed.shipmentSellingTotal, 2)} {totalCurrency}
                    </strong>
                ),
                profit: (
                    <strong>
                        <MDTypography
                            variant="caption"
                            fontWeight="bold"
                            color={getProfitColor(pricingComputed.totalProfit)}
                        >
                            {formatNumber(pricingComputed.totalProfit, 2)} {totalCurrency}
                        </MDTypography>
                    </strong>
                ),
            },
        ],
    };

    const totalsTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Gross Weight</b>, accessor: "grossWeight" },
            { Header: () => <b>LDM</b>, accessor: "ldm" },
            { Header: () => <b>Unit</b>, accessor: "unit" },
            { Header: () => <b>Chargeable Weight</b>, accessor: "chargeableWeight" },
        ],
        rows: [
            ...computed.rows.map((r) => ({
                shipmentNo: (
                    <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        color="info"
                        sx={linkTextSx}
                        onClick={() => handleGoShipmentForm(r.id)}
                    >
                        {r.shipmentNo}
                    </MDTypography>
                ),
                grossWeight: formatNumber(r.grossWeight, 4),
                ldm: formatNumber(r.ldm, 4),
                unit: formatNumber(r.unit, 0),
                chargeableWeight: formatNumber(r.chargeableWeight, 4),
            })),
            {
                shipmentNo: <strong>TOTAL</strong>,
                grossWeight: <strong>{formatNumber(computed.totals.grossWeight, 4)}</strong>,
                ldm: <strong>{formatNumber(computed.totals.ldm, 4)}</strong>,
                unit: <strong>{formatNumber(computed.totals.unit, 0)}</strong>,
                chargeableWeight: <strong>{formatNumber(computed.totals.chargeableWeight, 4)}</strong>,
            },
        ],
    };

    // Writes the truck corrections made on this page to their RHFLs; returns the updated RHFLs.
    const saveRhflTruckEdits = async () => {
        const updated = {};
        for (const [shipmentId, edits] of Object.entries(rhflTruckEdits)) {
            const trucks = Object.entries(edits).map(([truckId, fields]) => ({ truckId, ...fields }));
            if (!trucks.length) continue;
            const res = await CrudService.updateShipmentTrucks(shipmentId, trucks);
            const attr = res?.data?.attributes || res?.data?.data?.attributes;
            if (attr) updated[shipmentId] = attr;
        }
        if (Object.keys(updated).length) {
            setCurrentRhfls((prev) => ({ ...prev, ...updated }));
        }
        setRhflTruckEdits({});
        return updated;
    };

    const saveMblToBackend = async () => {
        const updatedRhfls = await saveRhflTruckEdits();
        const latestRhfls = { ...currentRhfls, ...updatedRhfls };
        const formData = new FormData();
        const shipmentCount = selectedShipmentsState.length || 1;
        const distributedProfit = safeNumber(financialSummary.totalProfit) / shipmentCount;

        const shipmentPricingForSave = { ...shipmentPricing };

        selectedShipmentsState.forEach((shipment) => {
            const id = shipment?.id;
            if (!id) return;

            shipmentPricingForSave[id] = {
                ...shipmentPricingForSave[id],
                profit: distributedProfit,
                profitCurrency: totalCurrency,
            };
        });
        // The snapshot keeps the RHFL's trucks current, so lists that read it show the plates.
        const truckFieldsOf = (attr) =>
            attr
                ? {
                    trucks: attr.trucks,
                    truckType: attr.truckType,
                    plateContainerNumber: attr.plateContainerNumber,
                    cmrNumber: attr.cmrNumber,
                    sealNumber: attr.sealNumber,
                }
                : {};
        const ltl = isLtlOperation();
        const rhflTrucks = selectedShipmentsState.flatMap((shipment) =>
            trucksFromSaved({ ...(latestRhfls[shipment.id] || shipment.attributes || {}), _id: shipment.id })
        );
        // File-level vehicle fields of the RMBL for older readers: its linehaul trucks (LTL)
        // or the RHFLs' trucks (FTL), keeping what the RMBL had when those are empty.
        const vehicle = trucksForPayload(ltl ? linehaulTrucks : rhflTrucks);
        const payload = {
            shipments: selectedShipmentsState.map((s) => ({
                id: s.id,
                attributes: { ...s.attributes, ...truckFieldsOf(latestRhfls[s.id]) },
            })),
            rmblNumber,

            pickupDate,
            pickupTime,
            proofOfDelivery,
            proofOfDeliveryTime,

            cob: actualDeparture,
            cobTime: actualDepartureTime,
            eta: estimatedDeliveryDate,
            etaTime: estimatedDeliveryTime,

            sealNumber: vehicle.sealNumber || (ltl ? "" : sealNumber),
            cmrNumber: vehicle.cmrNumber || (ltl ? "" : cmrNumber),
            plateContainerNumber: vehicle.plateContainerNumber || (ltl ? "" : plateContainerNumber),
            ...(ltl
                ? {
                    trucks: linehaulTrucks.map((t) => ({ ...t, buyingRate: safeNumber(t.buyingRate) })),
                    truckAssignments: Object.fromEntries(
                        selectedShipmentsState.map((shipment) => [shipment.id, assignedTruckId(shipment.id)])
                    ),
                }
                : {}),

            originalEtaDate,
            aadDate,
            aadTime,
            rdlDate,
            rdlTime,
            delayReason: hasEtaDelay || delayReason ? delayReason : "",

            pickupLocation: {
                ...pickupLocation,
                additionalInfo: normalizeStringField(pickupLocation?.additionalInfo),
            },
            deliveryLocation: {
                ...deliveryLocation,
                additionalInfo: normalizeStringField(deliveryLocation?.additionalInfo),
            },

            locationHistory,
            shipmentPricing: shipmentPricingForSave,
            linehaulDetails: {
                provider: selectedLinehaulProvider,
                cost: safeNumber(linehaulCost),
                currency: linehaulCurrency,
            },
            handlingDetails: {
                cost: safeNumber(handlingCost),
                currency: handlingCurrency,
            },
            bookingResponsibleParty,

            originAgentEnabled,
            originActualType,

            destinationAgentEnabled,
            destinationActualType,

            finalMblShipper,
            finalMblConsignee,

            selectedBookingAgent: {
                id: selectedBookingAgent?.id || "",
                name: getAgentName(selectedBookingAgent),
                globalAgentCountry: selectedBookingAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedBookingAgent?.servicesCountry),
            },

            selectedOriginAgent: {
                id: selectedOriginAgent?.id || "",
                name: getAgentName(selectedOriginAgent),
                globalAgentCountry: selectedOriginAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedOriginAgent?.servicesCountry),
            },

            selectedDestinationAgent: {
                id: selectedDestinationAgent?.id || "",
                name: getAgentName(selectedDestinationAgent),
                globalAgentCountry: selectedDestinationAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedDestinationAgent?.servicesCountry),
            },
            financialSummary: {
                shipmentCostTotal: safeNumber(financialSummary.shipmentCostTotal),
                convertedLinehaulCost: safeNumber(financialSummary.convertedLinehaulCost),
                convertedHandlingCost: safeNumber(financialSummary.convertedHandlingCost),
                totalCost: safeNumber(financialSummary.totalCost),
                totalSellingRate: safeNumber(financialSummary.totalSellingRate),
                totalProfit: safeNumber(financialSummary.totalProfit),
                totalCurrency: totalCurrency,
            },
        };
        formData.append("data", JSON.stringify(payload));

        if (t1t2?.[0]) formData.append("t1t2", t1t2[0]);
        if (linehaulCarrier?.[0]) formData.append("linehaulCarrier", linehaulCarrier[0]);
        if (cmr?.[0]) formData.append("cmr", cmr[0]);

        const existingId = mblIdFromUrl || createdMblIdRef.current;
        if (existingId) {
            await CrudService.updateMBL(formData, existingId);
            return existingId;
        }

        const res = await CrudService.createMBL(formData);
        const created = res?.data?.id ? res.data : res?.data?.data;
        if (created?.id) createdMblIdRef.current = created.id;
        // The backend assigns the real number on create; show that one from now on.
        if (created?.attributes?.rmblNumber) setRmblNumber(created.attributes.rmblNumber);
        return created?.id;
    };

    // Rapid double clicks share one request instead of each creating a record.
    const saveMblToBackendOnce = () => {
        if (!saveInFlightRef.current) {
            saveInFlightRef.current = saveMblToBackend().finally(() => {
                saveInFlightRef.current = null;
            });
        }
        return saveInFlightRef.current;
    };

    const handleGoToConsolidation = async () => {
        try {
            setSaving(true);

            const mblId = await saveMblToBackendOnce();

            navigate("/shipping-order/shipment-consolidation/consolidation", {
                state: {
                    fromMbl: true,
                    mblId,
                },
            });
        } catch (err) {
            console.error("RMBL save error:", err?.response?.data || err);
            appAlert("RMBL could not be saved. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    const TITLE_SX = {
        fontWeight: "bold",
        lineHeight: 1.15,
        minHeight: 40,
        mb: 1,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
    };

    const DROPZONE_WRAPPER_SX = {
        width: "100%",
        maxWidth: "120px",
        height: "130px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const DZ_STYLE = {
        height: "90px",
        minHeight: "90px",
        maxHeight: "90px",
        fontSize: "8px",
        overflow: "hidden",
    };

    const FIELD_SX = {
        "& .MuiOutlinedInput-root": {
            minHeight: 56,
            boxSizing: "border-box",
            borderRadius: "10px",
            backgroundColor: "#fff",
            alignItems: "center",
            paddingRight: "39px !important",

            "& input": {
                padding: "16.5px 14px",
                boxSizing: "border-box",
            },

            "& fieldset": {
                top: 0,
            },
        },

        "& .MuiInputBase-root": {
            boxSizing: "border-box",
        },

        "& .MuiInputBase-input": {
            boxSizing: "border-box",
        },

        "& .MuiAutocomplete-inputRoot": {
            paddingTop: "0 !important",
            paddingBottom: "0 !important",
            minHeight: "56px",
            alignItems: "center",
        },

        "& .MuiAutocomplete-input": {
            padding: "7.5px 4px !important",
            minWidth: "0 !important",
        },

        "& .MuiAutocomplete-endAdornment": {
            top: "50%",
            transform: "translateY(-50%)",
        },

        "& .MuiInputLabel-root": {
            zIndex: 1,
            backgroundColor: "#fff",
            padding: "0 4px",
        },

        "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
        },
    };


    const pickupLatLng = useMemo(() => {
        const str = pickupLocation?.latLong || "";
        const [lat, lng] = str.split(",").map((x) => Number(String(x).trim()));
        if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
        return null;
    }, [pickupLocation?.latLong]);

    const deliveryLatLng = useMemo(() => {
        const str = deliveryLocation?.latLong || "";
        const [lat, lng] = str.split(",").map((x) => Number(String(x).trim()));
        if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
        return null;
    }, [deliveryLocation?.latLong]);

    const historyShipmentNo = useMemo(() => {
        const s0 = selectedShipmentsState?.[0]?.attributes?.shipmentNo;
        return s0 || firstAttr?.shipmentNo;
    }, [selectedShipmentsState, firstAttr]);

    const historyShipmentId = useMemo(() => {
        return selectedShipmentsState?.[0]?.id || null;
    }, [selectedShipmentsState]);

    const handleGoMblForm = () => {
        if (!mblIdFromUrl) return;
        navigate(`/shipping-order/connect-mbl?id=${mblIdFromUrl}`);
    };

    const handleGoShipmentForm = (shipmentId) => {
        if (!shipmentId) return;
        navigate(`/shipping-order/create-shipment/details?id=${shipmentId}`);
    };


    const getFirstShipmentAttr = () => {
        return selectedShipmentsState?.[0]?.attributes || {};
    };

    const normalizeText = (value) =>
        String(value || "")
            .trim()
            .toLowerCase();

    const normalizeCountryList = (value) => {
        if (!value) return [];

        if (Array.isArray(value)) {
            return value
                .map((item) => {
                    if (typeof item === "string") return item;
                    return item?.label || item?.name || item?.country || "";
                })
                .filter(Boolean);
        }

        if (typeof value === "object") {
            return [value.label || value.name || value.country || ""].filter(Boolean);
        }

        return [value].filter(Boolean);
    };

    const countryMatches = (agentCountries, targetCountry) => {
        const normalizedTarget = normalizeText(targetCountry);

        if (!normalizedTarget) return false;

        return agentCountries.some(
            (country) => normalizeText(country) === normalizedTarget
        );
    };

    const getAgentName = (agent) => {
        const raw = agent?.raw || agent?.attributes || agent || {};
        return agent?.name || raw.name || raw.companyName || "";
    };

    const getAgentCountries = (agent) => {
        const raw = agent?.raw || agent?.attributes || agent || {};

        return [
            ...normalizeCountryList(agent?.globalAgentCountry),
            ...normalizeCountryList(agent?.servicesCountry),
            ...normalizeCountryList(raw.globalAgentCountry),
            ...normalizeCountryList(raw.servicesCountry),
        ].filter(Boolean);
    };

    const getOriginCountry = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.pickupLocation?.country ||
            first?.exportLocation?.country ||
            first?.originCountry ||
            ""
        );
    };

    const getDestinationCountry = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.deliveryLocation?.country ||
            first?.importLocation?.country ||
            first?.destinationCountry ||
            ""
        );
    };

    const getActualShipper = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.shipper?.companyName ||
            first?.shipper?.name ||
            first?.shipper ||
            ""
        );
    };

    const getActualConsignee = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.consignee?.companyName ||
            first?.consignee?.name ||
            first?.consignee ||
            ""
        );
    };

    const originCountry = getOriginCountry();
    const destinationCountry = getDestinationCountry();

    const filterAgentsByCountry = (targetCountry) => {
        if (!targetCountry) return [];

        return globalAgentOptions.filter((agent) => {
            const countries = getAgentCountries(agent);
            return countryMatches(countries, targetCountry);
        });
    };

    const originAgentOptions = useMemo(() => {
        return filterAgentsByCountry(originCountry);
    }, [globalAgentOptions, originCountry]);

    const destinationAgentOptions = useMemo(() => {
        return filterAgentsByCountry(destinationCountry);
    }, [globalAgentOptions, destinationCountry]);

    const finalMblShipper = useMemo(() => {
        if (originAgentEnabled === "YES") {
            return getAgentName(selectedOriginAgent);
        }

        if (originAgentEnabled === "NO") {
            if (originActualType === "FILENDERS") return FILENDERS_NAME;
            if (originActualType === "ACTUAL") return getActualShipper();
        }

        return "";
    }, [
        originAgentEnabled,
        selectedOriginAgent,
        originActualType,
        selectedShipmentsState,
    ]);

    const finalMblConsignee = useMemo(() => {
        if (destinationAgentEnabled === "YES") {
            return getAgentName(selectedDestinationAgent);
        }

        if (destinationAgentEnabled === "NO") {
            if (destinationActualType === "FILENDERS") return FILENDERS_NAME;
            if (destinationActualType === "ACTUAL") return getActualConsignee();
        }

        return "";
    }, [
        destinationAgentEnabled,
        selectedDestinationAgent,
        destinationActualType,
        selectedShipmentsState,
    ]);

    const partiesTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Actual Shipper</b>, accessor: "shipper" },
            { Header: () => <b>Actual Consignee</b>, accessor: "consignee" },
            { Header: () => <b>Final MBL Shipper</b>, accessor: "finalMblShipper" },
            { Header: () => <b>Final MBL Consignee</b>, accessor: "finalMblConsignee" },
        ],
        rows: computed.rows.map((r) => ({
            shipmentNo: (
                <MDTypography
                    variant="caption"
                    fontWeight="bold"
                    color="info"
                    sx={linkTextSx}
                    onClick={() => handleGoShipmentForm(r.id)}
                >
                    {r.shipmentNo}
                </MDTypography>
            ),
            shipper: r.shipper,
            consignee: r.consignee,
            finalMblShipper: (
                <MDTypography variant="button" fontWeight="bold" color="info">
                    {finalMblShipper || "-"}
                </MDTypography>
            ),
            finalMblConsignee: (
                <MDTypography variant="button" fontWeight="bold" color="success">
                    {finalMblConsignee || "-"}
                </MDTypography>
            ),
        })),
    };



    // ---- trucks ------------------------------------------------------------------------
    const linkedIdsKey = selectedShipmentsState.map((s) => s?.id).filter(Boolean).join(",");

    useEffect(() => {
        const ids = linkedIdsKey ? linkedIdsKey.split(",") : [];
        if (!ids.length) return undefined;
        let cancelled = false;

        const load = async () => {
            setRhflsLoading(true);
            const entries = await Promise.all(
                ids.map(async (id) => {
                    try {
                        const res = await CrudService.getShipmentById(id);
                        return [id, res?.data?.attributes || res?.data?.data?.attributes || null];
                    } catch (error) {
                        // A deleted or unreadable RHFL keeps its snapshot.
                        return [id, null];
                    }
                })
            );
            if (cancelled) return;
            setCurrentRhfls(Object.fromEntries(entries.filter(([, attr]) => attr)));
            setRhflsLoading(false);
        };

        load();
        return () => {
            cancelled = true;
        };
    }, [linkedIdsKey]);

    const rhflRows = useMemo(
        () =>
            selectedShipmentsState.map((shipment) => {
                const attributes = currentRhfls[shipment.id] || shipment.attributes || {};
                const edits = rhflTruckEdits[shipment.id] || {};
                // The id keeps a legacy RHFL's one truck id stable even while only its snapshot is known.
                const trucks = trucksFromSaved({ ...attributes, _id: attributes._id || shipment.id }).map((truck) => ({
                    ...truck,
                    ...(edits[truck.truckId] || {}),
                }));
                return { id: shipment.id, attributes, trucks, edited: Object.keys(edits).length > 0 };
            }),
        [selectedShipmentsState, currentRhfls, rhflTruckEdits]
    );

    const editRhflTruck = (shipmentId, truckId, field, value) =>
        setRhflTruckEdits((prev) => ({
            ...prev,
            [shipmentId]: {
                ...(prev[shipmentId] || {}),
                [truckId]: { ...(prev[shipmentId]?.[truckId] || {}), [field]: value },
            },
        }));

    const assignedTruckId = (shipmentId) => {
        const id = truckAssignments[shipmentId];
        return linehaulTrucks.some((t) => t.truckId === id) ? id : linehaulTrucks[0]?.truckId;
    };

    const rhflsOnTruck = (truckId) => selectedShipmentsState.filter((s) => assignedTruckId(s.id) === truckId);

    const linehaulLoadFor = (truckId) =>
        rhflsOnTruck(truckId).reduce(
            (acc, shipment) => {
                const row = computed.rows.find((r) => r.id === shipment.id) || {};
                const totals = (currentRhfls[shipment.id] || shipment.attributes || {}).totals || {};
                acc.unitQuantity += safeNumber(row.unit);
                acc.grossWeight += safeNumber(row.grossWeight);
                acc.cbm += safeNumber(totals.totalCbm);
                acc.ldm += safeNumber(row.ldm);
                acc.chargeableWeight += safeNumber(row.chargeableWeight);
                return acc;
            },
            { unitQuantity: 0, grossWeight: 0, cbm: 0, ldm: 0, chargeableWeight: 0 }
        );

    const linehaulCarriedLabel = (truckId) =>
        rhflsOnTruck(truckId)
            .map((s) => `RHFL${s.attributes?.shipmentNo || ""}`)
            .join(", ");

    // RHFLs of a removed linehaul truck move to the truck the user was told about.
    const moveAssignments = (removedId, targetId) =>
        setTruckAssignments((prev) => {
            const next = {};
            selectedShipmentsState.forEach((s) => {
                const current = assignedTruckId(s.id);
                next[s.id] = current === removedId ? targetId : current;
            });
            return { ...prev, ...next };
        });

    // The linehaul cost is the total of the linehaul trucks' rates once any truck has one.
    const linehaulCostFromTrucks = linehaulTrucks.some((t) => safeNumber(t.buyingRate) > 0);
    const linehaulTruckRateTotal = totalBuyingRate(linehaulTrucks);

    // ---- schedule ------------------------------------------------------------------------
    const hasEtaDelay = useMemo(() => {
        if (!originalEtaDate || !estimatedDeliveryDate) return false;
        const original = new Date(originalEtaDate).setHours(0, 0, 0, 0);
        const current = new Date(estimatedDeliveryDate).setHours(0, 0, 0, 0);
        return current > original;
    }, [originalEtaDate, estimatedDeliveryDate]);

    const handleEtaDateChange = (nextValue) => {
        setEstimatedDeliveryDate(nextValue);
        if (!originalEtaDate && nextValue) setOriginalEtaDate(nextValue);
    };

    // ---- freight charges: the RHFLs' own costs by kind, in the total currency ----------
    const freightBreakdown = useMemo(() => {
        const sum = (rateKey, currencyKey) =>
            selectedShipmentsState.reduce((acc, shipment) => {
                const a = shipment.attributes || {};
                return acc + convertCurrency(safeNumber(a[rateKey]), a[currencyKey] || "EUR", totalCurrency, exchangeRates);
            }, 0);
        return {
            pickup: sum("pickupRate", "pickupRateCurrency"),
            freight: sum("buyingRate", "buyingRateCurrency"),
            customs:
                sum("exportCustomsRate", "exportCustomsRateCurrency") +
                sum("importCustomsRate", "importCustomsRateCurrency"),
            delivery: sum("deliveryRate", "deliveryRateCurrency"),
        };
    }, [selectedShipmentsState, totalCurrency, exchangeRates]);

    const getRoadTransportModeLabel = () => {
        const first = getFirstShipmentAttr();
        return first?.roadTransportType || "";
    };

    const isLtlOperation = () => {
        const mode = String(getRoadTransportModeLabel() || "").toUpperCase();
        return mode.includes("LTL");
    };

    const isFtlOperation = () => {
        const mode = String(getRoadTransportModeLabel() || "").toUpperCase();
        return mode.includes("FTL");
    };

    const buildRhflNumberList = (shipments = selectedShipmentsState) => {
        return (shipments || [])
            .map((s) => {
                const no = s?.attributes?.shipmentNo;
                return no ? `RHFL${no}` : null;
            })
            .filter(Boolean);
    };

    const buildBaseShipmentPayloadFromMbl = (first = getFirstShipmentAttr()) => {

        return {
            ...first,

            shipmentNo: first?.shipmentNo || "",
            cmrNumber: cmrNumber || first?.cmrNumber || rmblNumber || "",
            plateContainerNumber:
                plateContainerNumber || first?.plateContainerNumber || "",
            sealNumber: sealNumber || first?.sealNumber || "",

            pickupDate: pickupDate || first?.pickupDate || null,
            pickupTime: pickupTime || first?.pickupTime || "",

            estimatedDeparture: estimatedDeparture || first?.estimatedDeparture || null,
            estimatedDepartureTime:
                estimatedDepartureTime || first?.estimatedDepartureTime || "",

            estimatedDeliveryDate:
                estimatedDeliveryDate || first?.estimatedDeliveryDate || null,
            estimatedDeliveryTime:
                estimatedDeliveryTime || first?.estimatedDeliveryTime || "",

            actualDeparture: actualDeparture || first?.actualDeparture || null,
            actualDepartureTime:
                actualDepartureTime || first?.actualDepartureTime || "",

            proofOfDelivery: proofOfDelivery || first?.proofOfDelivery || null,
            proofOfDeliveryTime:
                proofOfDeliveryTime || first?.proofOfDeliveryTime || "",

            pickupLocation: {
                ...(first?.pickupLocation || {}),
                ...(pickupLocation || {}),
            },
            deliveryLocation: {
                ...(first?.deliveryLocation || {}),
                ...(deliveryLocation || {}),
            },

            exportLocation: {
                ...(first?.exportLocation || {}),
            },
            importLocation: {
                ...(first?.importLocation || {}),
            },

            serviceProvider:
                selectedLinehaulProvider?.name ||
                selectedLinehaulProvider ||
                first?.serviceProvider ||
                "FILENDERS LOGISTICS AND TECHNOLOGY",

            buyingRate: linehaulCost || first?.buyingRate || "",
            buyingRateCurrency: linehaulCurrency || first?.buyingRateCurrency || "EUR",

            sellingRate:
                financialSummary?.totalSellingRate || first?.sellingRate || "",
            sellingRateCurrency:
                totalCurrency || first?.sellingRateCurrency || "EUR",

            profit: financialSummary?.totalProfit || first?.profit || "",

            cargoDetails: Array.isArray(first?.cargoDetails) ? first.cargoDetails : [],
        };
    };
    const buildMergedCargoDetailsForMultiLtl = (shipments = selectedShipmentsState) => {
        return (shipments || []).flatMap((shipment) => {
            const attr = currentRhfls[shipment?.id] || shipment?.attributes || {};
            const cargoList = Array.isArray(attr.cargoDetails) ? attr.cargoDetails : [];

            return cargoList.map((cargo) => ({
                commodity: cargo?.commodity || "",
                description: cargo?.description || "",
                hsCode: cargo?.hsCode || "",
                selectedPackingType: cargo?.selectedPackingType || "",
                unitQuantity: cargo?.unitQuantity || "",
                grossWeight: cargo?.grossWeight || "",
                cbm: cargo?.cbm || "",
                ldm: cargo?.ldm || "",
                chargeableWeight: cargo?.chargeableWeight || "",
            }));
        });
    };

    const buildMapDeliveryPointLines = () => {
        const points = [];

        const mainDeliveryLabel = [
            deliveryLocation?.additionalInfo,
            [deliveryLocation?.zipcode, deliveryLocation?.district, deliveryLocation?.city]
                .filter(Boolean)
                .join(" "),
            deliveryLocation?.country,
        ]
            .filter(Boolean)
            .join(", ");

        if (deliveryLocation?.latLong || mainDeliveryLabel) {
            points.push({
                source: "main",
                label: mainDeliveryLabel || deliveryLocation?.latLong || "",
            });
        }

        const historyDeliveryPoints = (locationHistory || []).filter(
            (item) =>
                item?.type === "delivery" ||
                String(item?.eventType || "").toLowerCase().includes("delivery address")
        );

        historyDeliveryPoints.forEach((item) => {
            points.push({
                source: "history",
                label: item?.label || "",
            });
        });

        return points
            .filter((item) => item.label)
            .map((item, index) => `${index + 1} - ${item.label}`);
    };
    const buildMapPickupAddressText = () => {
        const pickupPoints = (locationHistory || []).filter(
            (item) =>
                item?.type === "pickup" ||
                item?.eventType === "Pickup Address" ||
                item?.eventType === "Pickup Location"
        );

        if (pickupPoints.length > 0) {
            return pickupPoints
                .map((item, index) => {
                    const label = item?.label || "";
                    return `PickupPOINT ${index + 1}${label ? ` - ${label}` : ""}`;
                })
                .join("\n");
        }

        const fallback = pickupLocation || getFirstShipmentAttr()?.pickupLocation || {};

        return [
            fallback.additionalInfo,
            [fallback.zipcode, fallback.district, fallback.city].filter(Boolean).join(" "),
            fallback.country,
        ]
            .filter(Boolean)
            .join("\n");
    };



    const buildMultiLtlCmrPayload = (shipments = selectedShipmentsState) => {
        const rhflNumbers = buildRhflNumberList(shipments);
        const rhflText = rhflNumbers.length ? rhflNumbers.join("\n") : "";

        const deliveryPointLines = buildMapDeliveryPointLines();
        const pickupAddressText = buildMapPickupAddressText();
        const mergedCargoDetails = buildMergedCargoDetailsForMultiLtl(shipments);
        const firstOfTruck = currentRhfls[shipments?.[0]?.id] || shipments?.[0]?.attributes || getFirstShipmentAttr();

        return {
            ...buildBaseShipmentPayloadFromMbl(firstOfTruck),

            // 1 ve 2
            shipper: rhflText,
            consignee: rhflText,

            // 3 -> haritadaki delivery addressler
            pickupLocation: {
                ...(pickupLocation || {}),
                additionalInfo: deliveryPointLines,
                zipcode: "",
                district: "",
                city: "",
                country: "",
            },

            // 4 -> haritadaki pickup address
            deliveryLocation: {
                ...(deliveryLocation || {}),
                additionalInfo: pickupAddressText,
                zipcode: "",
                district: "",
                city: "",
                country: "",
            },

            // 5 -> boş
            attachedDocuments: "",
            documentsAttached: "",

            // 6-12 -> tüm RHFL cargoDetails kalem kalem
            cargoDetails: mergedCargoDetails,

            // 13 -> boş
            billTo: "",
            notify: "",
            manufacturer: "",
            quoteNo: "",

            // 14 -> generateCmrPdf zaten sabit FREIGHT PREPAID basıyor

            // 15 -> boş
            profit: "",

            // 16 -> seçilen service provider
            serviceProvider:
                selectedLinehaulProvider?.name ||
                selectedLinehaulProvider ||
                "",

            // 17 -> FILENDERS LOGISTICS AND TECHNOLOGY
            customDetail: {
                customNote: "FILENDERS LOGISTICS AND TECHNOLOGY",
            },

            // 18 -> plate
            plateContainerNumber: plateContainerNumber || "",

            // 19 -> boş bırakmak için kaynak alanları temizle
            roadTransportType: "",
            truckType: "",
            t1DeclarationNumber: "",
            sealNumber: "",
            adr: false,
            imco: "",

            // 20 -> boş bırakmak için tüm rate alanlarını temizle
            buyingRate: "",
            buyingRateCurrency: "",
            pickupRate: "",
            pickupRateCurrency: "",
            deliveryRate: "",
            deliveryRateCurrency: "",
            exportCustomsRate: "",
            exportCustomsRateCurrency: "",
            importCustomsRate: "",
            importCustomsRateCurrency: "",
            sellingRate: "",
            sellingRateCurrency: "",

            // 21 -> MERSIN, TURKEY + COB tarihi
            establishedPlaceText: "MERSIN, TURKEY",
            establishedDate: actualDeparture || null,

            // 22 -> FILENDERS LOGISTICS AND TECHNOLOGY
            senderSignatureText: "FILENDERS LOGISTICS AND TECHNOLOGY",

            // 23 -> boş
            carrierSignatureText: "",

            // 24 -> boş
            goodsReceivedPlaceText: "",
            goodsReceivedDate: null,
            consigneeSignatureText: "",

            totals: {
                totalGrossWeight: computed?.totals?.grossWeight || 0,
                totalLdm: computed?.totals?.ldm || 0,
                totalUnit: computed?.totals?.unit || 0,
                totalChargeableWeight: computed?.totals?.chargeableWeight || 0,
            },
        };
    };
    // One CMR per vehicle. FTL: every truck of every RHFL, each with its own plate, documents and
    // the cargo it carries. LTL: every linehaul truck with the RHFLs it carries, consolidated
    // when it carries more than one.
    const buildCmrDocumentsForMbl = () => {
        if (!isLtlOperation()) {
            const totalTrucks = rhflRows.reduce((sum, row) => sum + row.trucks.length, 0);
            return rhflRows.flatMap((row) => {
                const attr = row.attributes || {};
                const base = buildBaseShipmentPayloadFromMbl(attr);
                return cmrPayloadsForTrucks({
                    ...base,
                    trucks: row.trucks,
                    cargoDetails: normalizeCargoList(attr.cargoDetails || [], row.trucks),
                    shipmentNo: attr.shipmentNo || "",
                }).map((data, i) => {
                    // A one-truck RMBL keeps the plate / CMR / seal entered on it before.
                    const only = totalTrucks === 1;
                    const doc = {
                        ...data,
                        plateContainerNumber: data.plateContainerNumber || (only ? plateContainerNumber : ""),
                        cmrNumber: row.trucks[i]?.cmrNumber || (only ? cmrNumber || base.cmrNumber : data.cmrNumber),
                        sealNumber: data.sealNumber || (only ? sealNumber : ""),
                    };
                    return {
                        label: `RHFL${attr.shipmentNo || ""} · ${doc.plateContainerNumber || `Truck ${i + 1}`}`,
                        data: doc,
                    };
                });
            });
        }

        return linehaulTrucks
            .map((truck, i) => {
                const carried = selectedShipmentsState.filter((s) => assignedTruckId(s.id) === truck.truckId);
                if (!carried.length) return null;
                const base =
                    carried.length === 1
                        ? buildBaseShipmentPayloadFromMbl(currentRhfls[carried[0].id] || carried[0].attributes || {})
                        : buildMultiLtlCmrPayload(carried);
                const plate = vehicleText(truck);
                return {
                    label: `Truck ${i + 1}${plate ? ` · ${plate}` : ""}`,
                    data: {
                        ...base,
                        plateContainerNumber: plate,
                        sealNumber: truck.sealNumber || "",
                        cmrNumber:
                            truck.cmrNumber || (linehaulTrucks.length > 1 ? `${rmblNumber}-${i + 1}` : base.cmrNumber),
                    },
                };
            })
            .filter(Boolean);
    };

    const handlePrintCmr = async () => {
        try {
            setSaving(true);

            await saveMblToBackendOnce();

            const documents = buildCmrDocumentsForMbl();
            if (!documents.length) {
                appAlert("No truck carries any RHFL yet. Assign the RHFLs to a linehaul truck first.");
                return;
            }
            setCmrDocuments(documents);
        } catch (err) {
            console.error("Print CMR error:", err?.response?.data || err);
            appAlert("CMR could not be generated. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    // Saves the RMBL and opens its invoice, as on the OMBL / AMBL pages.
    const handleGoInvoice = async () => {
        try {
            setSaving(true);

            if (!selectedShipmentsState.length) {
                appAlert("This RMBL has no linked shipments. Invoice cannot be created.");
                return;
            }

            const mblId = await saveMblToBackendOnce();
            const res = await CrudService.getMBLById(mblId);
            const attr = res?.data?.data?.attributes || res?.data?.attributes;
            const payload = buildRmblInvoicePayload(attr);

            if (!payload) {
                appAlert("This RMBL has no linked shipments. Invoice cannot be created.");
                return;
            }

            setInvoiceState({
                shipments: payload.formattedShipments,
                linehaulServiceProviderMap: payload.linehaulServiceProviderMap,
                fromMbl: true,
                rmbl: attr,
                sourceType: "road",
            });
            setInvoiceDialogOpen(true);
        } catch (err) {
            console.error("Invoice open error:", err?.response?.data || err);
            appAlert("Invoice could not be opened. Please try again.");
        } finally {
            setSaving(false);
        }
    };


    const linehaulCostLocked = isLtlOperation() && linehaulCostFromTrucks;
    // When the last truck rate is cleared or its truck removed, the cost it set goes too;
    // an RMBL whose cost was never taken from trucks keeps the one typed in.
    const linehaulCostWasLockedRef = useRef(false);
    useEffect(() => {
        if (linehaulCostLocked) setLinehaulCost(String(linehaulTruckRateTotal));
        else if (linehaulCostWasLockedRef.current) setLinehaulCost("");
        linehaulCostWasLockedRef.current = linehaulCostLocked;
    }, [linehaulCostLocked, linehaulTruckRateTotal]);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
            <DashboardLayout>
                <DashboardNavbar />

                <CmrPrintDialog
                    open={Boolean(cmrDocuments)}
                    documents={cmrDocuments}
                    onClose={() => setCmrDocuments(null)}
                />

                <Dialog
                    open={invoiceDialogOpen}
                    onClose={() => setInvoiceDialogOpen(false)}
                    maxWidth="xl"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: "20px", minHeight: "90vh" } }}
                >
                    <DialogContent sx={{ p: 3 }}>
                        {invoiceState && (
                            <ViewShipments
                                embedded
                                invoiceState={invoiceState}
                                onClose={() => setInvoiceDialogOpen(false)}
                            />
                        )}
                    </DialogContent>
                </Dialog>

                <MDBox pt={4} pb={3}>
                    <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={2}
                        mb={3}
                        sx={{
                            position: "relative",
                            overflow: "hidden",
                            px: { xs: 2, md: 2.75 },
                            py: { xs: 2.25, md: 2.5 },
                            borderRadius: "0 0 18px 18px",
                            background:
                                "#14213f",
                            boxShadow: "0 14px 34px rgba(15,23,42,0.24)",
                            color: "#fff",
                            "&:before": {
                                content: '""',
                                position: "absolute",
                                right: 92,
                                bottom: -82,
                                width: 150,
                                height: 150,
                                borderRadius: "50%",
                                background: "rgba(34,197,94,0.16)",
                            },
                            "&:after": {
                                content: '""',
                                position: "absolute",
                                right: -35,
                                top: -70,
                                width: 190,
                                height: 190,
                                borderRadius: "50%",
                                background: "rgba(14,165,233,0.26)",
                            },
                        }}
                    >
                        <MDBox position="relative" zIndex={1}>
                            <MDBox display="flex" gap={0.75} alignItems="center" mb={1}>
                                <Chip
                                    label="Road RMBL"
                                    size="small"
                                    sx={{
                                        height: 22,
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: 11,
                                        border: "1px solid rgba(255,255,255,0.38)",
                                        background: "rgba(255,255,255,0.12)",
                                        backdropFilter: "blur(8px)",
                                    }}
                                />

                                {isEditMode ? (
                                    <Chip
                                        label="Edit Mode"
                                        size="small"
                                        sx={{
                                            height: 22,
                                            color: "#111827",
                                            fontWeight: "bold",
                                            fontSize: 11,
                                            background: "#f59e0b",
                                        }}
                                    />
                                ) : null}

                                <Chip
                                    label={`${selectedShipmentsState.length || 0} linked shipment${
                                        selectedShipmentsState.length > 1 ? "s" : ""
                                    }`}
                                    size="small"
                                    sx={{
                                        height: 22,
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: 11,
                                        background: "#0ea5e9",
                                    }}
                                />
                            </MDBox>

                            <MDTypography
                                variant="h4"
                                fontWeight="bold"
                                sx={{
                                    color: "#fff",
                                    lineHeight: 1.15,
                                    textShadow: "0 2px 8px rgba(0,0,0,0.22)",
                                }}
                            >
                                {isEditMode ? `EDIT - ${rmblNumber || ""}` : "CONNECT RMBL"}
                            </MDTypography>

                            <MDTypography
                                variant="button"
                                sx={{
                                    color: "rgba(255,255,255,0.82)",
                                    display: "block",
                                    mt: 1,
                                }}
                            >
                                Manage road shipment linkage, RMBL financial control, documents and live location history.
                            </MDTypography>
                        </MDBox>

                        <MDBox
                            display="flex"
                            gap={1}
                            flexWrap="wrap"
                            position="relative"
                            zIndex={1}
                            sx={{
                                width: { xs: "100%", md: "auto" },
                                justifyContent: { xs: "flex-start", md: "flex-end" },
                            }}
                        >
                            <MDButton
                                variant="outlined"
                                color="white"
                                onClick={() => navigate(-1)}
                                sx={{
                                    minWidth: 88,
                                    color: "#fff",
                                    borderColor: "rgba(255,255,255,0.45)",
                                    background: "rgba(255,255,255,0.08)",
                                    "&:hover": {
                                        borderColor: "#fff",
                                        background: "rgba(255,255,255,0.16)",
                                    },
                                }}
                            >
                                Back
                            </MDButton>

                            <MDButton
                                variant="contained"
                                onClick={handlePrintCmr}
                                disabled={saving || !hasData}
                                sx={{
                                    minWidth: 160,
                                    color: "#111827",
                                    background: "#fff",
                                    "&:hover": {
                                        background: "#f8fafc",
                                    },
                                    "&.Mui-disabled": {
                                        background: "rgba(255,255,255,0.55)",
                                        color: "rgba(17,24,39,0.55)",
                                    },
                                }}
                            >
                                {saving ? "Preparing CMR..." : "Print CMR"}
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="info"
                                onClick={handleGoInvoice}
                                disabled={saving || !hasData}
                                sx={{ minWidth: 200 }}
                            >
                                {saving ? "Saving..." : "Save & Invoice Details"}
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="success"
                                onClick={handleGoToConsolidation}
                                disabled={saving || !hasData}
                                sx={{
                                    minWidth: 240,
                                    background: "#22c55e",
                                    color: "#fff",
                                    boxShadow: "0 10px 24px rgba(34,197,94,0.28)",
                                    "&:hover": {
                                        background: "#16a34a",
                                    },
                                }}
                            >
                                {saving
                                    ? "Saving..."
                                    : isEditMode
                                        ? "Update & Go to Consolidation"
                                        : "Save & Go to Consolidation"}
                            </MDButton>
                        </MDBox>
                    </MDBox>

                    {hasData ? (
                        <KpiStrip sx={{ mb: 3 }}>
                            <FinanceKpi label="RMBL No" value={rmblNumber || "-"} hint={isEditMode ? "Saved record" : "New record"} />
                            <FinanceKpi
                                label="Linked Shipments"
                                value={selectedShipmentsState.length}
                                hint={selectedShipmentsState.length === 1 ? "House file" : "House files"}
                            />
                            <FinanceKpi
                                label="Total Gross Weight"
                                value={`${formatQuantity(computed.totals.grossWeight)} kg`}
                                hint={`${formatQuantity(computed.totals.ldm)} LDM · ${formatQuantity(computed.totals.unit, 0)} units`}
                            />
                            <FinanceKpi
                                label="Total Selling"
                                value={formatMoney(financialSummary.totalSellingRate, totalCurrency)}
                                hint={`Cost ${formatMoney(financialSummary.totalCost, totalCurrency)}`}
                            />
                            <FinanceKpi
                                label="Gross Profit"
                                value={formatMoney(financialSummary.totalProfit, totalCurrency)}
                                toneKey={profitTone(financialSummary.totalProfit)}
                                hint={`${profitLabel(financialSummary.totalProfit)} · ${formatPercent(profitMargin)} margin`}
                            />
                        </KpiStrip>
                    ) : null}
                    {hasData && (
                        <SectionCard
                            title="MBL Party Configuration"
                            subtitle="Select how MBL shipper and consignee will be determined from RHFL, Filenders or Global Agent records."
                        >
                            <MDBox
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    borderRadius: "14px",
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            select
                                            label="Booking Responsible Party"
                                            value={bookingResponsibleParty}
                                            onChange={(e) => {
                                                setBookingResponsibleParty(e.target.value);
                                                setSelectedBookingAgent(null);
                                            }}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                        >
                                            <MenuItem value="GLOBAL_AGENT">Global Agent</MenuItem>
                                            <MenuItem value="FILENDERS">Filenders</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {bookingResponsibleParty === "GLOBAL_AGENT" && (
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                options={globalAgentOptions}
                                                value={selectedBookingAgent}
                                                onChange={(_e, newValue) => setSelectedBookingAgent(newValue)}
                                                getOptionLabel={(option) => getAgentName(option)}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Booking Global Agent"
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </MDBox>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            borderRadius: "10px",
                                            border: "1px solid #dbeafe",
                                            backgroundColor: "#ffffff",
                                            boxShadow: "none",
                                            height: "100%",
                                        }}
                                    >
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <MDBox>
                                                <MDTypography variant="h6" fontWeight="bold" color="info">
                                                    Origin / MBL Shipper
                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    Origin country: {originCountry || "Not selected"}
                                                </MDTypography>
                                            </MDBox>
                                        </MDBox>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={5}>
                                                <TextField
                                                    select
                                                    label="Use Origin Global Agent?"
                                                    value={originAgentEnabled}
                                                    onChange={(e) => {
                                                        setOriginAgentEnabled(e.target.value);
                                                        setSelectedOriginAgent(null);
                                                        setOriginActualType("");
                                                    }}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="YES">Yes - Use Global Agent</MenuItem>
                                                    <MenuItem value="NO">No - Use Filenders / Actual Shipper</MenuItem>
                                                </TextField>
                                            </Grid>

                                            {originAgentEnabled === "YES" && (
                                                <Grid item xs={12} md={7}>
                                                    <Autocomplete
                                                        options={originAgentOptions}
                                                        value={selectedOriginAgent}
                                                        onChange={(_e, newValue) => setSelectedOriginAgent(newValue)}
                                                        getOptionLabel={(option) => getAgentName(option)}
                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                        noOptionsText={
                                                            originCountry
                                                                ? `No Global Agent found for origin country: ${originCountry}`
                                                                : "Origin country not found"
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={`Global Agent for ${originCountry || "Origin"}`}
                                                                fullWidth
                                                                size="small"
                                                                sx={FIELD_SX}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}

                                            {originAgentEnabled === "NO" && (
                                                <Grid item xs={12} md={7}>
                                                    <TextField
                                                        select
                                                        label="MBL Shipper Source"
                                                        value={originActualType}
                                                        onChange={(e) => setOriginActualType(e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                        InputLabelProps={{ shrink: true }}
                                                    >
                                                        <MenuItem value="FILENDERS">Filenders</MenuItem>
                                                        <MenuItem value="ACTUAL">Actual Shipper from RHFL</MenuItem>
                                                    </TextField>
                                                </Grid>
                                            )}
                                        </Grid>

                                        <MDBox
                                            mt={2}
                                            p={2}
                                            sx={{
                                                borderRadius: "12px",
                                                backgroundColor: "#eff6ff",
                                                border: "1px dashed #93c5fd",
                                            }}
                                        >
                                            <MDTypography variant="caption" color="text">
                                                Final MBL Shipper
                                            </MDTypography>
                                            <MDTypography variant="h6" fontWeight="bold" color="info">
                                                {finalMblShipper || "-"}
                                            </MDTypography>

                                            {originActualType === "ACTUAL" && (
                                                <MDTypography variant="caption" color="text">
                                                    Actual RHFL Shipper: {getActualShipper() || "-"}
                                                </MDTypography>
                                            )}
                                        </MDBox>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            borderRadius: "10px",
                                            border: "1px solid #dcfce7",
                                            backgroundColor: "#ffffff",
                                            boxShadow: "none",
                                            height: "100%",
                                        }}
                                    >
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <MDBox>
                                                <MDTypography variant="h6" fontWeight="bold" color="success">
                                                    Destination / MBL Consignee
                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    Destination country: {destinationCountry || "Not selected"}
                                                </MDTypography>
                                            </MDBox>
                                        </MDBox>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={5}>
                                                <TextField
                                                    select
                                                    label="Use Destination Global Agent?"
                                                    value={destinationAgentEnabled}
                                                    onChange={(e) => {
                                                        setDestinationAgentEnabled(e.target.value);
                                                        setSelectedDestinationAgent(null);
                                                        setDestinationActualType("");
                                                    }}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="YES">Yes - Use Global Agent</MenuItem>
                                                    <MenuItem value="NO">No - Use Filenders / Actual Consignee</MenuItem>
                                                </TextField>
                                            </Grid>

                                            {destinationAgentEnabled === "YES" && (
                                                <Grid item xs={12} md={7}>
                                                    <Autocomplete
                                                        options={destinationAgentOptions}
                                                        value={selectedDestinationAgent}
                                                        onChange={(_e, newValue) => setSelectedDestinationAgent(newValue)}
                                                        getOptionLabel={(option) => getAgentName(option)}
                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                        noOptionsText={
                                                            destinationCountry
                                                                ? `No Global Agent found for destination country: ${destinationCountry}`
                                                                : "Destination country not found"
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={`Global Agent for ${destinationCountry || "Destination"}`}
                                                                fullWidth
                                                                size="small"
                                                                sx={FIELD_SX}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}

                                            {destinationAgentEnabled === "NO" && (
                                                <Grid item xs={12} md={7}>
                                                    <TextField
                                                        select
                                                        label="MBL Consignee Source"
                                                        value={destinationActualType}
                                                        onChange={(e) => setDestinationActualType(e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                        InputLabelProps={{ shrink: true }}
                                                    >
                                                        <MenuItem value="FILENDERS">Filenders</MenuItem>
                                                        <MenuItem value="ACTUAL">Actual Consignee from RHFL</MenuItem>
                                                    </TextField>
                                                </Grid>
                                            )}
                                        </Grid>

                                        <MDBox
                                            mt={2}
                                            p={2}
                                            sx={{
                                                borderRadius: "12px",
                                                backgroundColor: "#f0fdf4",
                                                border: "1px dashed #86efac",
                                            }}
                                        >
                                            <MDTypography variant="caption" color="text">
                                                Final MBL Consignee
                                            </MDTypography>
                                            <MDTypography variant="h6" fontWeight="bold" color="success">
                                                {finalMblConsignee || "-"}
                                            </MDTypography>

                                            {destinationActualType === "ACTUAL" && (
                                                <MDTypography variant="caption" color="text">
                                                    Actual RHFL Consignee: {getActualConsignee() || "-"}
                                                </MDTypography>
                                            )}
                                        </MDBox>
                                    </Card>
                                </Grid>
                            </Grid>
                        </SectionCard>
                    )}
                    {!hasData ? (
                        <Card
                            sx={{
                                p: 3,
                                borderRadius: "14px",
                                border: "1px solid #eee",
                                boxShadow: "none",
                            }}
                        >
                            <Alert severity="warning">
                                No selected shipments found. Please go back and select RHFL shipments first.
                            </Alert>
                        </Card>
                    ) : (
                        <>
                            <SectionCard
                                title="RMBL Details"
                                subtitle="Linked RHFL and truck references, schedule and delay tracking for the RMBL."
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={7}>
                                        <Card
                                            sx={{
                                                p: 2,
                                                borderRadius: "12px",
                                                border: "1px solid #f0f0f0",
                                                height: "100%",
                                                boxShadow: "none",
                                            }}
                                        >
                                            <RmblReferences
                                                rmblNumber={rmblNumber}
                                                onOpenRmbl={isEditMode ? handleGoMblForm : undefined}
                                                rows={rhflRows}
                                                loading={rhflsLoading}
                                                onEditTruck={editRhflTruck}
                                                onOpenShipment={handleGoShipmentForm}
                                                linehaulTrucks={isLtlOperation() ? linehaulTrucks : null}
                                                truckAssignments={Object.fromEntries(
                                                    selectedShipmentsState.map((sh) => [sh.id, assignedTruckId(sh.id)])
                                                )}
                                                onAssign={(shipmentId, truckId) =>
                                                    setTruckAssignments((prev) => ({ ...prev, [shipmentId]: truckId }))
                                                }
                                                fieldSx={FIELD_SX}
                                                linkSx={linkTextSx}
                                            />
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12} md={5}>
                                        <Card
                                            sx={{
                                                p: 2,
                                                borderRadius: "12px",
                                                border: "1px solid #f0f0f0",
                                                height: "100%",
                                                boxShadow: "none",
                                            }}
                                        >
                                            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                    Schedule Details
                                                </MDTypography>
                                                <Chip
                                                    size="small"
                                                    label={hasEtaDelay ? "Delay Detected" : "On Schedule"}
                                                    sx={{
                                                        fontWeight: "bold",
                                                        color: hasEtaDelay ? "#b45309" : "#15803d",
                                                        backgroundColor: hasEtaDelay ? "#fffbeb" : "#f0fdf4",
                                                    }}
                                                />
                                            </MDBox>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <DatePicker
                                                        label="ETA"
                                                        value={estimatedDeliveryDate}
                                                        onChange={handleEtaDateChange}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                size: "small",
                                                                sx: FIELD_SX,
                                                                InputLabelProps: {
                                                                    shrink: true,
                                                                    component: RequiredLabelWithTooltip({
                                                                        label: "ETA",
                                                                        tooltip: "Estimated Time of Arrival",
                                                                    }),
                                                                },
                                                            },
                                                            actionBar: { actions: ["clear", "accept"] },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="ETA Time"
                                                        type="time"
                                                        value={estimatedDeliveryTime}
                                                        onChange={(e) => setEstimatedDeliveryTime(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ step: 900 }}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <DatePicker
                                                        label="COB"
                                                        value={actualDeparture}
                                                        onChange={setActualDeparture}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                size: "small",
                                                                sx: FIELD_SX,
                                                                InputLabelProps: {
                                                                    shrink: true,
                                                                    component: RequiredLabelWithTooltip({
                                                                        label: "COB",
                                                                        tooltip: "Confirmed On Board",
                                                                    }),
                                                                },
                                                            },
                                                            actionBar: { actions: ["clear", "accept"] },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="COB Time"
                                                        type="time"
                                                        value={actualDepartureTime}
                                                        onChange={(e) => setActualDepartureTime(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ step: 900 }}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <DatePicker
                                                        label="AAD"
                                                        value={aadDate}
                                                        onChange={setAadDate}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                size: "small",
                                                                sx: FIELD_SX,
                                                                InputLabelProps: { shrink: true },
                                                            },
                                                            actionBar: { actions: ["clear", "accept"] },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="AAD Time"
                                                        type="time"
                                                        value={aadTime}
                                                        onChange={(e) => setAadTime(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ step: 900 }}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                    />
                                                </Grid>

                                                {(hasEtaDelay || Boolean(delayReason)) && (
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            label="Delay Reason"
                                                            value={delayReason}
                                                            onChange={(e) => setDelayReason(e.target.value)}
                                                            fullWidth
                                                            multiline
                                                            minRows={3}
                                                            size="small"
                                                            sx={FIELD_SX}
                                                            InputLabelProps={{ shrink: true }}
                                                            placeholder="The ETA has been postponed. Please explain the reason for the delay..."
                                                        />
                                                    </Grid>
                                                )}

                                                <Grid item xs={12} sm={6}>
                                                    <DatePicker
                                                        label="RDL Date"
                                                        value={rdlDate}
                                                        onChange={setRdlDate}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                size: "small",
                                                                sx: FIELD_SX,
                                                                InputLabelProps: { shrink: true },
                                                            },
                                                            actionBar: { actions: ["clear", "accept"] },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="RDL Time"
                                                        type="time"
                                                        value={rdlTime}
                                                        onChange={(e) => setRdlTime(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ step: 900 }}
                                                        fullWidth
                                                        size="small"
                                                        sx={FIELD_SX}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </SectionCard>

                            {isLtlOperation() && (
                                <SectionCard
                                    title="Linehaul Trucks"
                                    subtitle="Vehicles of this RMBL. Each linked RHFL is carried by the truck chosen on its reference card; Print CMR prints one consolidated CMR per truck."
                                >
                                    <TrucksSection
                                        title="Linehaul Trucks"
                                        trucks={linehaulTrucks}
                                        setTrucks={setLinehaulTrucks}
                                        truckTypeOptions={TRUCK_TYPE_OPTIONS}
                                        buyingRateCurrency={linehaulCurrency}
                                        setBuyingRateCurrency={setLinehaulCurrency}
                                        inputSx={FIELD_SX}
                                        loadTotalsFor={linehaulLoadFor}
                                        assignedLabelFor={linehaulCarriedLabel}
                                        onTruckRemoved={moveAssignments}
                                    />
                                </SectionCard>
                            )}

                            <SectionCard
                                title="Documents"
                                subtitle="Upload related operational and transport documents."
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <DocumentUploadCard
                                            title="T1/T2"
                                            files={t1t2}
                                            setFiles={setT1t2}
                                            titleSx={TITLE_SX}
                                            wrapperSx={DROPZONE_WRAPPER_SX}
                                            dzStyle={DZ_STYLE}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <DocumentUploadCard
                                            title="Vendor/Supplier Invoice (Linehaul Carrier)"
                                            files={linehaulCarrier}
                                            setFiles={setLinehaulCarrier}
                                            titleSx={TITLE_SX}
                                            wrapperSx={DROPZONE_WRAPPER_SX}
                                            dzStyle={DZ_STYLE}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <DocumentUploadCard
                                            title="Filenders CMR"
                                            files={cmr}
                                            setFiles={setCmr}
                                            titleSx={TITLE_SX}
                                            wrapperSx={DROPZONE_WRAPPER_SX}
                                            dzStyle={DZ_STYLE}
                                        />
                                    </Grid>
                                </Grid>
                            </SectionCard>

                            <SectionCard
                                title="Selected Shipments Totals"
                                subtitle="Operational totals calculated from the connected RHFL shipments."
                            >
                                <KpiStrip sx={{ mb: 2, boxShadow: "none" }}>
                                    <FinanceKpi label="Gross Weight" value={`${formatQuantity(computed.totals.grossWeight)} kg`} />
                                    <FinanceKpi label="LDM" value={formatQuantity(computed.totals.ldm)} hint="Loading metres" />
                                    <FinanceKpi label="Units" value={formatQuantity(computed.totals.unit, 0)} />
                                    <FinanceKpi
                                        label="Chargeable Weight"
                                        value={`${formatQuantity(computed.totals.chargeableWeight)} kg`}
                                    />
                                </KpiStrip>

                                <DataTable table={totalsTable} canSearch />
                            </SectionCard>

                            <SectionCard
                                title="Shipper / Consignee"
                                subtitle="Party details for the linked shipments."
                            >
                                <DataTable table={partiesTable} canSearch />
                            </SectionCard>

                            <SectionCard
                                title="Cost / Selling Rate"
                                subtitle="Review shipment-based cost and selling distribution."
                                rightAction={
                                    <TextField
                                        select
                                        label="Total Currency"
                                        value={totalCurrency}
                                        onChange={(e) => {
                                            totalCurrencyTouchedRef.current = true;
                                            setTotalCurrency(e.target.value);
                                        }}
                                        size="small"
                                        sx={{ minWidth: 160, ...FIELD_SX }}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {CURRENCY_OPTIONS.map((c) => (
                                            <MenuItem key={c} value={c}>
                                                {c}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                }
                            >
                                <DataTable table={pricingTable} canSearch={false} />
                            </SectionCard>

                            <SectionCard
                                title="Linehaul Details"
                                subtitle="Assign service provider, cost and transaction currency."
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Autocomplete
                                            options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                                            value={selectedLinehaulProvider}
                                            onChange={(event, newValue) => {
                                                if (newValue?.type === "new") {
                                                    setServiceProviderModalOpen(true);
                                                    return;
                                                }

                                                setSelectedLinehaulProvider(newValue);
                                            }}
                                            getOptionLabel={(option) => option?.name || ""}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            renderOption={({ key: optionKey, ...props }, option) => (
                                                <li {...props} key={option.id}>
                                                    {option.type === "new" ? (
                                                        <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                    ) : (
                                                        option.name
                                                    )}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Linehaul Service Provider"
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    size="small"
                                                    sx={FIELD_SX}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            type="number"
                                            label={linehaulCostLocked ? "Linehaul Cost (trucks total)" : "Linehaul Cost"}
                                            value={linehaulCost}
                                            onChange={(e) => setLinehaulCost(e.target.value)}
                                            InputProps={{ readOnly: linehaulCostLocked }}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            sx={FIELD_SX}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            select
                                            label="Currency"
                                            value={linehaulCurrency}
                                            onChange={(e) => setLinehaulCurrency(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            sx={FIELD_SX}
                                        >
                                            {CURRENCY_OPTIONS.map((c) => (
                                                <MenuItem key={c} value={c}>
                                                    {c}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            type="number"
                                            label="Handling Cost"
                                            value={handlingCost}
                                            onChange={(e) => setHandlingCost(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            sx={FIELD_SX}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            select
                                            label="Handling Currency"
                                            value={handlingCurrency}
                                            onChange={(e) => setHandlingCurrency(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            sx={FIELD_SX}
                                        >
                                            {CURRENCY_OPTIONS.map((c) => (
                                                <MenuItem key={c} value={c}>
                                                    {c}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </SectionCard>

                            <SectionCard
                                title="Freight Charges"
                                subtitle="P/U, freight, customs and delivery costs come from the linked RHFL files. Linehaul and Handling are entered above."
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="P/U Cost"
                                            value={`${formatNumber(freightBreakdown.pickup, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="RHFL Freight"
                                            value={`${formatNumber(freightBreakdown.freight, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="Customs"
                                            value={`${formatNumber(freightBreakdown.customs, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="Delivery Cost"
                                            value={`${formatNumber(freightBreakdown.delivery, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="Linehaul"
                                            value={`${formatNumber(financialSummary.convertedLinehaulCost, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            label="Handling"
                                            value={`${formatNumber(financialSummary.convertedHandlingCost, 2)} ${totalCurrency}`}
                                            fullWidth
                                            size="small"
                                            sx={FIELD_SX}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </SectionCard>

                            <SectionCard
                                title="Financial Summary"
                                subtitle="Freight charges, selling rate and final profitability snapshot."
                            >
                                <FinancialSummaryPanel
                                    costLines={[
                                        { label: "Pick-up", value: freightBreakdown.pickup },
                                        { label: "RHFL Freight", value: freightBreakdown.freight },
                                        { label: "Customs", value: freightBreakdown.customs },
                                        { label: "Delivery", value: freightBreakdown.delivery },
                                        { label: "Linehaul", value: financialSummary.convertedLinehaulCost },
                                        { label: "Handling", value: financialSummary.convertedHandlingCost },
                                    ]}
                                    cost={financialSummary.totalCost}
                                    selling={financialSummary.totalSellingRate}
                                    profit={financialSummary.totalProfit}
                                    margin={profitMargin}
                                    currency={totalCurrency}
                                    costLabel="Total Cost"
                                />
                            </SectionCard>

                            <SectionCard
                                title="Shipment History Details"
                                subtitle="Track and update shipment location history."
                                rightAction={
                                    <MDBox display="flex" gap={1}>
                                        <MDButton
                                            variant="outlined"
                                            color="info"
                                            onClick={() => setDeliveryPickerOpen(true)}
                                        >
                                            Add Delivery Point
                                        </MDButton>

                                        <MDButton
                                            variant="contained"
                                            color="warning"
                                            onClick={() => setPickupPickerOpen(true)}
                                        >
                                            Add Location History
                                        </MDButton>
                                    </MDBox>
                                }
                            >
                                <LocationHistory
                                    rmblNumber={rmblNumber}
                                    mblId={mblIdFromUrl}
                                    onGoMbl={handleGoMblForm}
                                    onGoShipment={handleGoShipmentForm}
                                    selectedShipmentsState={selectedShipmentsState}
                                    locationHistory={locationHistory}
                                    setLocationHistory={setLocationHistory}
                                    pickupDate={pickupDate}
                                    pickupTime={pickupTime}
                                    pickupLocation={pickupLocation}
                                    proofOfDelivery={proofOfDelivery}
                                    proofOfDeliveryTime={proofOfDeliveryTime}
                                    deliveryLocation={deliveryLocation}
                                />
                            </SectionCard>
                        </>
                    )}
                </MDBox>

                <MDBox
                    position="sticky"
                    bottom={0}
                    zIndex={20}
                    py={2}
                    sx={{
                        backdropFilter: "blur(8px)",
                        background: "rgba(255,255,255,0.85)",
                        borderTop: "1px solid #eee",
                    }}
                >
                    <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1.5}
                    >
                        <MDBox>
                            <MDTypography variant="button" fontWeight="bold">
                                {isEditMode ? `Editing RMBL: ${rmblNumber || "-"}` : "Ready to continue?"}
                            </MDTypography>
                            <MDTypography variant="caption" color="text" display="block">
                                Save the current RMBL and continue to the consolidation step.
                            </MDTypography>
                        </MDBox>

                        <MDBox display="flex" gap={1}>
                            <MDButton variant="outlined" color="dark" onClick={() => navigate(-1)}>
                                Back
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="info"
                                onClick={handlePrintCmr}
                                disabled={saving || !hasData}
                            >
                                {saving ? "Preparing CMR..." : "Print CMR"}
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="info"
                                onClick={handleGoInvoice}
                                disabled={saving || !hasData}
                            >
                                {saving ? "Saving..." : "Save & Invoice Details"}
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="success"
                                onClick={handleGoToConsolidation}
                                disabled={saving || !hasData}
                            >
                                {saving
                                    ? "Saving..."
                                    : isEditMode
                                        ? "Update & Go to Consolidation"
                                        : "Save & Go to Consolidation"}
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>

                <Footer />

                <LocationPickerModal
                    open={pickupPickerOpen}
                    title="Add Location History Point"
                    valueLatLng={null}
                    onClose={() => setPickupPickerOpen(false)}
                    onSelect={async (latlng) => {
                        try {
                            const res = await fetch(
                                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}`
                            );

                            const data = await res.json();

                            const city =
                                data.address.city ||
                                data.address.town ||
                                data.address.village ||
                                data.address.state ||
                                "";

                            const country = data.address.country || "";

                            const label = [city, country].filter(Boolean).join(", ");

                            setLocationHistory((prev) => [
                                ...(Array.isArray(prev) ? prev : []),
                                {
                                    label: label || `${latlng.lat}, ${latlng.lng}`,
                                    lat: latlng.lat,
                                    lon: latlng.lng,
                                    addedAt: new Date().toISOString(),
                                },
                            ]);
                        } catch (err) {
                            console.error("reverse geocode error", err);
                        }

                        setPickupPickerOpen(false);
                        setRefreshLocationHistory((x) => !x);
                    }}
                />

                <LocationPickerModal
                    open={deliveryPickerOpen}
                    title="Select Delivery Location"
                    valueLatLng={deliveryLatLng}
                    onClose={() => setDeliveryPickerOpen(false)}
                    onSelect={async (latlng) => {
                        try {
                            const res = await fetch(
                                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}`
                            );

                            const data = await res.json();

                            const city =
                                data.address.city ||
                                data.address.town ||
                                data.address.village ||
                                data.address.state ||
                                "";

                            const country = data.address.country || "";

                            setLocationHistory((prev) => {
                                const safePrev = Array.isArray(prev) ? prev : [];

                                return [
                                    ...safePrev,
                                    {
                                        type: "delivery",
                                        eventType: "Delivery Address",
                                        label: [city, country].filter(Boolean).join(", ") || `${latlng.lat}, ${latlng.lng}`,
                                        lat: latlng.lat,
                                        lon: latlng.lng,
                                        addedAt: new Date().toISOString(),
                                    },
                                ];
                            });
                        } catch (err) {
                            console.error("Reverse geocode error", err);
                        }

                        setDeliveryPickerOpen(false);
                        setRefreshLocationHistory((x) => !x);
                    }}
                />

        <Dialog
            open={serviceProviderModalOpen}
            onClose={() => setServiceProviderModalOpen(false)}
            maxWidth="xl"
            fullWidth
        >
          <DialogTitle>
            Create Service Provider
            <IconButton
                onClick={() => setServiceProviderModalOpen(false)}
                sx={{ position: "absolute", right: 12, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <CreateServiceProvider
                isModal
                onClose={() => setServiceProviderModalOpen(false)}
                onCreated={handleServiceProviderCreatedFromModal}
            />
          </DialogContent>
        </Dialog>
            </DashboardLayout>
        </LocalizationProvider>
    );
};

export default ConnectMBL;